import * as actions from './actions';

const initialState = {
    products: [],
    isInitializedProducts: false,
    isLoading: false,
    errorProducts: null,
    count: null,
    next: null,
    previous: null,
    total_pages: null,


};



export default function productsReducer(state = initialState, { type, ...action }) {
    switch (type) {
        case actions.FETCH_PRODUCTS.SUCCESS:
            return {
                ...state,
                products: action.payload.products,
                isInitializedProducts: true,
            }
        case actions.FETCH_PRODUCTS_BY_PAGE.SUCCESS: {
            const { results, count, next, previous, total_pages } = action.payload.products;
            return {
                ...state,
                count,
                next,
                previous,
                total_pages,
                products: results,
                isInitializedProducts: true,
            }
        }

        case actions.FETCH_PRODUCTS_BY_FILTER.SUCCESS: {
            const { results, count, next, previous, total_pages } = action.payload.products;
            return {
                ...state,
                count,
                next,
                previous,
                total_pages,
                products: results,
                isInitializedProducts: true,
            }
        }

        default:
            return state;
    }

}